import type { Category } from '@ilteducation/content-ref-data-types';
import { computed } from 'vue';

export const MATERIAL_CATEGORY_ALL_ID = 'all';

// Real categories get their icon from admin, but this one is synthetic, so it carries the same
// rectangle-history mark polylino uses -- on the landing page bubble and the drop-down alike.
export const MATERIAL_CATEGORY_ALL_ICON = 'fal fa-rectangle-history';

const useAllMaterialsCategory = () => {
  const allMaterialsCategory = computed(
    () =>
      ({
        id: MATERIAL_CATEGORY_ALL_ID,
        categoryCode: 'category_all_materials',
        icon: MATERIAL_CATEGORY_ALL_ICON,
      }) as Category,
  );

  return {
    allMaterialsCategory,
  };
};

export default useAllMaterialsCategory;
